import { Component } from '@angular/core';

@Component({
  selector: 'i-timer',
  imports: [],
  templateUrl: './i-timer.html',
  host: {
    class: 'grid place-items-center',
  },
})
export class ITimer {}
